module.exports = __webpack_public_path__ + "static/img/home_product.0d530cab.png";